/** Get a given `DD/MM/YYYY` string and format it to `YYYY-MM-DD`. */
export function formatDateStringToISOString(date: string) {
  const [day, month, year] = date.split("/");
  return `${year}-${month}-${day}`;
}
